export enum FareTypeEnum {
    ADULT = 1,          // tarifa adulto
    SCHOOL = 2,         // tarifa escolar
    DISABILITY = 3,     // tarifa universitario
    EXONERATED = 4,     // tarifa exonerado
    OLD_AGE = 5         // tarifa media
}